<micro-select-combo #sel
              placeholder="Task Carrier"
              routerBase="task/taskCarriers"
              [mode]="mode"
              [(id)]="taskCarrierId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              platformService="taskd"
>
</micro-select-combo>
